import { useCallback, useEffect, useLayoutEffect, useRef } from "react";

import { offset } from "@floating-ui/dom";

import {
  useFloatingWindowsActions,
  useIsFloatingWindowOpen,
} from "src/base-components/FloatingWindow/hooks";

const CASE_COPILOT_WINDOW_ID = "case-copilot";

export const useCaseCopilot = () => {
  const { open: openWindow, close: closeWindow } = useFloatingWindowsActions();
  const copilotTargetRef = useRef<HTMLDivElement | null>(null);
  const isOpen = useIsFloatingWindowOpen(CASE_COPILOT_WINDOW_ID);

  const openCaseCopilot = useCallback(() => {
    openWindow({
      id: CASE_COPILOT_WINDOW_ID,
      type: "case-copilot",
      target: copilotTargetRef,
      positionOptions: {
        placement: "right-start",
        middleware: [offset({ mainAxis: 10, alignmentAxis: 10 })],
      },
    });
  }, [openWindow]);

  const closeCaseCopilot = useCallback(() => {
    closeWindow(CASE_COPILOT_WINDOW_ID);
  }, [closeWindow]);

  const toggleCaseCopilot = useCallback(() => {
    if (isOpen) {
      closeCaseCopilot();
    } else {
      openCaseCopilot();
    }
  }, [isOpen, closeCaseCopilot, openCaseCopilot]);

  useLayoutEffect(() => {
    const casePageContainer = document.querySelector(
      "[data-loc=case-page-content]",
    );
    copilotTargetRef.current = casePageContainer as HTMLDivElement;
  }, []);

  useEffect(() => {
    return () => {
      closeWindow(CASE_COPILOT_WINDOW_ID);
    };
  }, [closeWindow]);

  return {
    openCaseCopilot,
    closeCaseCopilot,
    toggleCaseCopilot,
    isOpen,
  };
};
